export enum PASSWORD_SOURCE {
    UserEntered = "UserEntered",
    SystemGenerated = "SystemGenerated"
}
